import type { BotMembership } from '../types';

interface Props {
  membership: BotMembership | null;
  canPost: boolean | null;
  checkedAt: number | null;
}

const styles: Record<BotMembership, string> = {
  administrator: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  creator:       'bg-emerald-50 text-emerald-700 border-emerald-200',
  member:        'bg-sky-50 text-sky-700 border-sky-200',
  restricted:    'bg-orange-50 text-orange-700 border-orange-200',
  left:          'bg-gray-50 text-gray-600 border-gray-200',
  kicked:        'bg-red-50 text-red-700 border-red-200',
  unreachable:   'bg-red-50 text-red-700 border-red-200',
  unknown:       'bg-gray-50 text-gray-500 border-gray-200',
};

const labels: Record<BotMembership, string> = {
  administrator: 'admin',
  creator:       'creator',
  member:        'member',
  restricted:    'restricted',
  left:          'left',
  kicked:        'kicked',
  unreachable:   'unreachable',
  unknown:       'unknown',
};

const titles: Record<BotMembership, string> = {
  administrator: 'Bot is admin in the Telegram chat — can post freely.',
  creator:       'Bot is the chat creator (uncommon).',
  member:        'Bot is a plain member. Can post if the chat allows non-admins to send messages.',
  restricted:    'Chat permissions explicitly block the bot from posting.',
  left:          'Bot left the chat.',
  kicked:        'Bot was removed from the chat.',
  unreachable:   'Telegram returns "chat not found" — chat was deleted or bot was removed and id no longer resolves.',
  unknown:       'Membership has not been observed yet (no scheduled fetch has run since the probe was deployed).',
};

export function BotRoleBadge({ membership, canPost, checkedAt }: Props) {
  if (!membership) {
    return <span className="text-xs text-gray-300">—</span>;
  }
  const cls = styles[membership] ?? styles.unknown;
  const tip = `${titles[membership]}${checkedAt ? ` Checked ${new Date(checkedAt).toISOString().slice(0, 16).replace('T', ' ')} UTC.` : ''}${canPost === false ? ' Bot cannot post.' : ''}`;
  return (
    <span
      title={tip}
      data-testid={`bot-role-badge-${membership}`}
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${cls}`}
    >
      {labels[membership]}
    </span>
  );
}
